exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".member-role-filter-container[data-v-0530bcda] {\n  margin-top: 0;\n  margin-bottom: 0;\n  width: 205px !important;\n}\n", ""]);

// exports
